import { Routes } from '@angular/router';
import { StatusReportComponent } from './status-report/status-report.component';
import { WarehouseReportComponent } from './warehouse-report/warehouse-report.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AllLibrariesComponent } from './all-libraries/all-libraries.component';
import { AllObjectsComponent } from './all-objects/all-objects.component';
import { LoginComponent } from './login/login.component';
import { AppAreasComponent } from './app-areas/app-areas.component';
import { ChartsComponent } from './charts/charts.component';
import { LibrariesComponent } from './charts/libraries/libraries.component';
import { InventoryComponent } from './charts/inventory/inventory.component';
import { DistributionComponent } from './charts/distribution/distribution.component';
import { SourceComponent } from './charts/source/source.component';
import { PhasesComponent } from './charts/phases/phases.component';
import { EntrypointsComponent } from './entrypoints/entrypoints.component';
import { SupportingObjectsComponent } from './charts/supporting-objects/supporting-objects.component';

const chartRoutes: Routes = [
  { path: 'Libraries', component: LibrariesComponent, data: { label: 'Libraries' } },
  { path: 'Inventory', component: InventoryComponent, data: { label: 'Inventory' } },
  { path: 'Distribution', component: DistributionComponent, data: { label: 'Distribution' } },
  { path: 'Sources', component: SourceComponent, data: { label: 'Source' } },
  { path: 'Phases', component: PhasesComponent, data: { label: 'Phases' } },
  { path: 'SupportingObjects', component: SupportingObjectsComponent, data: { label: 'Supporting Objects' } }
];

export const routes: Routes = [
  { path: 'Home', component: DashboardComponent, data: { label: 'Home', hide: true } },
  { path: 'status-report', component: StatusReportComponent, data: { label: 'Status Report', hide: true } },
  { path: 'Warehouse-report', component: WarehouseReportComponent, data: { label: 'Warehouse Report', hide: true } },
  { path: 'Libraries', component: AllLibrariesComponent, data: { label: 'Libraries' } },
  { path: 'ApplicationAreas', component: AppAreasComponent, data: { label: 'Application Areas' } },
  { path: 'Scoping', component: AllObjectsComponent, data: { label: 'Scoping', viewType: "Scoping" } },
  { path: 'ObjectLevelOverride', component: AllObjectsComponent, data: { label: 'Object Level Overrides', viewType: "ObjectLevelOverride" } },
  { path: 'SourceResolution', component: AllObjectsComponent, data: { label: 'Source Resolution', viewType: "SourceResolution" } },
  { path: 'EntryPoints', component: EntrypointsComponent, data: { label: 'EntryPoints' } },
  { path: "Charts", component: ChartsComponent, data: { label: 'Charts', viewType: "Charts" }, children: chartRoutes },
  { path: '', component: LoginComponent, pathMatch: 'full' }
];
